import { render, staticRenderFns } from "./provinsi.vue?vue&type=template&id=e4a95df4"
import script from "./provinsi.vue?vue&type=script&lang=js"
export * from "./provinsi.vue?vue&type=script&lang=js"
import style0 from "./provinsi.vue?vue&type=style&index=0&id=e4a95df4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports